export default __webpack_public_path__ + "static/media/trr-food-toast-supernova.f11bb3eb.png";